const ROUTES = {
    LOGIN: '/login',

    PASSWORD_RECOVERY: '/password/recovery',
    PASSWORD_RESET: '/password/reset',

    BATCH_FILE: '/batch-file',

    DASHBOARD: '/dashboard',
    CREDIT_POLICIES: '/credit-policies',
    CREDIT_POLICIES_LIST: '/credit-policies/list',
    CREDIT_POLICIES_CREATE: '/credit-policies/create',

    BYPASS_LIST: '/bypass-customers',
    CUSTOMERS: '/customers',
    SCORE: '/score'
}

export default ROUTES
